import "src/decidim/participatory_processes/filters"

// Images
require.context("../images", true)
